import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PageHeader from "../../components/common/PageHeader";
import TeamManagement from "../../components/tools/TeamManagement";
import { usePermissions } from "../../hooks/usePermissions";
import AccessDeniedPage from "../AccessDeniedPage";

const TeamPage = () => {
  const { canAccessRoute } = usePermissions();

  // Verificar se usuário tem acesso à página de equipe
  if (!canAccessRoute('/team')) {
    return <AccessDeniedPage />;
  }

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Equipe" />

        {/* Header */}
        <PageHeader
          icon="mdi:account-group"
          title="Gerenciamento de Equipe"
          subtitle="Gerencie usuários, permissões e controle de acesso da sua conta"
        />

        {/* TeamManagement */}
        <TeamManagement />
      </MasterLayout>
    </>
  );
};

export default TeamPage; 
